var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2658_2770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.992 23.0043C20.7505 23.0043 24.608 19.1458 24.608 14.3861C24.608 9.62636 20.7505 5.76785 15.992 5.76785C11.2335 5.76785 7.37598 9.62636 7.37598 14.3861C7.37598 19.1458 11.2335 23.0043 15.992 23.0043Z",
    stroke: "#0FA0DB",
    strokeWidth: 2.7945
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71579 39C4.32501 33.1819 9.67231 28.9063 15.9918 28.9063C22.3114 28.9063 27.6587 33.1819 29.2679 39H31.2962C29.6367 32.0752 23.401 26.9445 15.9751 26.9445C8.54921 26.9445 2.34701 32.0752 0.6875 39H2.71579Z",
    fill: "#0FA0DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5356 14.3861C29.5356 6.908 23.4675 0.838348 15.9914 0.838348C8.5152 0.838348 2.46387 6.908 2.46387 14.3861",
    stroke: "#0FA0DB",
    strokeWidth: 2.7945
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5439 19.5503C13.5439 18.7287 14.1977 18.0748 15.0191 18.0748H25.8478V25.4523H13.5439V19.5503Z",
    fill: "#EAF0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92824 11.9213H0V19.2988H4.92824V11.9213Z",
    fill: "#0FA0DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9995 11.9213H27.0713V19.2988H31.9995V11.9213Z",
    fill: "#0FA0DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9194 20.5396H15.9912V25.469H20.9194V20.5396Z",
    fill: "#0FA0DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5362 16.834V20.0365C29.5362 21.6629 28.2119 22.9875 26.586 22.9875H18.4561",
    stroke: "#0FA0DB",
    strokeWidth: 2.7945
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2658_2770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.aa45128db3d49fb692f5edec13240895.svg";
export { ForwardRef as ReactComponent };